import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../../data/mock';
import StarburstDecor from '../ui/StarburstDecor';

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonial = testimonials[currentIndex];

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="bg-lime py-16">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy font-display mb-8">TESTIMONIAL</h2>
            
            <p className="text-xl text-navy leading-relaxed mb-8">
              {testimonial.content}
            </p>

            <div className="flex items-center gap-4">
              <button
                onClick={prev}
                className="w-12 h-12 bg-navy text-white rounded-full flex items-center justify-center hover:bg-opacity-80 transition-colors"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                onClick={next}
                className="w-12 h-12 bg-navy text-white rounded-full flex items-center justify-center hover:bg-opacity-80 transition-colors"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square max-w-md ml-auto rounded-2xl overflow-hidden transform rotate-3">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 lg:left-auto lg:-right-4">
              <StarburstDecor size={100} color="navy" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
